import { useEffect, useRef, type ReactNode } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { useAuth } from "~/hooks/useAuth";

export function QuerySessionBoundary({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const previousUserId = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    const nextUserId = user?.id ?? null;
    if (
      previousUserId.current !== undefined &&
      previousUserId.current !== nextUserId &&
      previousUserId.current !== null
    ) {
      // Reset rather than clear: clear() detaches mounted observers, so signing
      // back in as the same user without a reload would never load their data.
      queryClient.resetQueries();
    }
    previousUserId.current = nextUserId;
  }, [queryClient, user?.id]);

  return children;
}
